const LOGIN = "api/common/login/";
const USER = "api/common/user/";
const USERList = "api/common/user/";
const ACCOUNTList = "api/common/account/";
const ACCOUNT_LIST_V2 = "api/common/v2/account/";
const RESPONSIBILITY = "api/proficiency/account/";
const RESPONSIBILITY_V2 = "api/proficiency/v2/account/";
const CURRENCY = "api/common/currencies/";
const PROFICIENCY_V1 = "api/proficiency/v1/account/";
const PROFICIENCY_V2 = "api/proficiency/v2/account/";
const COMMON_V1 = "api/common/v1/";
const ASK_IQ = "ask";
const GET_SUGGESTIONS = "get_suggestions/";
const APP_CONFIG = "api/app-config";

export const API = {
  LOGIN,
  USER,
  USERList,
  ACCOUNTList,
  ACCOUNT_LIST_V2,
  RESPONSIBILITY,
  RESPONSIBILITY_V2,
  CURRENCY,
  PROFICIENCY_V1,
  PROFICIENCY_V2,
  COMMON_V1,
  ASK_IQ,
  GET_SUGGESTIONS,
  APP_CONFIG,
};
